import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { SectionTitle, Card, Field, SaveButton } from "../ui";

const FIELD = "w-full bg-white border border-sand-200 rounded-lg px-3 py-2 text-sm text-charcoal-800 focus:outline-none focus:ring-2 focus:ring-sage/50";

export default function HomepageManager() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/home-settings").then((res) => setS(res.data));
  }, []);

  const save = async () => {
    setSaving(true);
    const { _id, ...payload } = s;
    await api.put("/admin/home-settings", payload);
    toast.success("Homepage saved");
    setSaving(false);
  };

  if (!s) return <p className="text-charcoal-500">Loading…</p>;

  const gallery = s.gallery || [];
  const setItem = (i, key, val) => {
    const g = [...gallery];
    g[i] = { ...g[i], [key]: val };
    setS({ ...s, gallery: g });
  };
  const addItem = () => setS({ ...s, gallery: [...gallery, { img: "", caption: "" }] });
  const removeItem = (i) => setS({ ...s, gallery: gallery.filter((_, idx) => idx !== i) });

  return (
    <div data-testid="admin-homepage">
      <SectionTitle title="Homepage" subtitle="Edit the binational card photos and the 'Places you'll come to love' gallery." />
      <div className="space-y-6">
        <Card>
          <h3 className="font-medium text-charcoal-800 mb-4">Binational card images</h3>
          <div className="space-y-4">
            <Field label="US side image URL (the journey)" testid="home-us-image" value={s.us_image} onChange={(v) => setS({ ...s, us_image: v })} />
            <Field label="Mexico side image URL (a place)" testid="home-mx-image" value={s.mx_image} onChange={(v) => setS({ ...s, mx_image: v })} />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-medium text-charcoal-800">Gallery — Places you'll come to love</h3>
            <button data-testid="home-gallery-add" onClick={addItem} className="inline-flex items-center gap-1 text-sm text-sage-700 hover:text-terracotta"><Plus size={15} /> Add photo</button>
          </div>
          <div className="space-y-4">
            {gallery.map((g, i) => (
              <div key={i} className="flex gap-4">
                {g.img && <img src={g.img} alt={g.caption} className="h-20 w-28 shrink-0 rounded-xl object-cover" />}
                <div className="flex-1 space-y-2">
                  <div className="flex gap-2">
                    <input data-testid={`home-gallery-img-${i}`} className={FIELD} placeholder="Image URL" value={g.img} onChange={(e) => setItem(i, "img", e.target.value)} />
                    <button data-testid={`home-gallery-del-${i}`} onClick={() => removeItem(i)} className="text-charcoal-400 hover:text-destructive shrink-0 px-2"><Trash2 size={16} /></button>
                  </div>
                  <input data-testid={`home-gallery-cap-${i}`} className={FIELD} placeholder="Caption" value={g.caption} onChange={(e) => setItem(i, "caption", e.target.value)} />
                </div>
              </div>
            ))}
          </div>
        </Card>

        <SaveButton testid="home-save" onClick={save} saving={saving} />
      </div>
    </div>
  );
}
